import styled from 'styled-components';
import { Container as BaseContainer } from 'styles/global.styled';
import { mediumBreakpoint } from 'utilities/constants';

export const Container = styled(BaseContainer)`
  background-color: #ffffff;

  @media (max-width: ${mediumBreakpoint}px) {
    background: linear-gradient(to top, white 80%, #f7fafc 90%);
  }

  h2 {
    color: #242424;
    font-size: 1.25em;
    font-family: 'Inter', sans-serif;
    font-weight: 400;
    line-height: 1.125;
    margin: 2em 0;
  }

  p {
    color: #959595;
    font-family: 'Inter', sans-serif;
    font-size: 1em;
    line-height: 1.875;
    font-weight: 300;
    max-width: 300px;
  }
`;

export const Inner = styled.div`
  flex-wrap: wrap;
  display: flex;
  align-items: flex-start;
  text-align: left;
  padding: 4rem 3rem;
  vertical-align: top;
  position: relative;
  max-width: 100%;
  border-radius: inherit;
  border-bottom: solid 1px #f3f3f3;

  @media (max-width: ${mediumBreakpoint}px) {
    flex-direction: column;
    flex-wrap: nowrap;
  }
`;
